import { FC } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useStores } from '../../../utils'
import styles from './index.module.scss'
import { CloseButton } from '../../atoms/CloseButton'
import { OutSideOverlay } from '../../atoms/OutSideOverlay'
import { IViewer } from '../../../types'

type Props = {
  viewer: IViewer
}

export const SetUpProfileToSendDMsPromotionModal: FC<Props> = observer(({ viewer }) => {
  const { t } = useTranslation(['companies-users-[id]'])
  const { ui } = useStores()

  const router = useRouter()
  const toggleModal = () => {
    ui.toggleSetUpProfileToSendDMsModal()
  }

  return (
    <div className={styles.container} style={ui.isSetUpProfileToSendDMsModalOpen ? {} : { display: 'none' }}>
      <OutSideOverlay onClick={toggleModal} isOpen={ui.isSetUpProfileToSendDMsModalOpen} backGroundColor='gray' />
      <div className={styles.modal}>
        <div className={styles.card}>
          <div className={styles.heading}>
            <h2>{t('顔写真と自己紹介を設定して下さい')}</h2>
            <div className={styles.closeButton}>
              <CloseButton onClick={toggleModal} />
            </div>
          </div>
          <div className={styles.text}>
            {t('メッセージを送信するには顔写真と自己紹介を設定する必要があります。')}
            <br className={styles.smInline} />
            {t('可能な限りプロフィールを充実させて返信率を高めましょう。')}
          </div>
          <div className={styles.unsetItems}>
            <div className={styles.item}>{t('未設定の項目')}</div>
            {!viewer.profile?.avatar && <div className={styles.item}>{t('- 顔写真')}</div>}
            {!viewer.profile?.jobTitle && <div className={styles.item}>{t('- 肩書')}</div>}
            {!viewer.profile?.bio && <div className={styles.item}>{t('- 自己紹介')}</div>}
          </div>
          <a className={styles.link} href={`/${router.locale}/account/profile`} target='_blank' rel='noreferrer'>
            <span className={styles.linkText}>{t('プロフィール編集画面へ')}</span>
            <span className={styles.linkIcon} />
          </a>
        </div>
      </div>
    </div>
  )
})
